# --------------------------------------------------*|
#   Common.Directives.ScrollFix
# --------------------------------------------------*|

'use strict'

angular.module("siter.io").directive "scrollFix", ["$window", ($window) ->
  restrict: "A"
  link: (scope, element, attrs) ->

    el = $(element)

    inner = document.createElement("p")
    inner.style.width = "100%"
    inner.style.height = "200px"
    outer = document.createElement("div")
    outer.style.position = "absolute"
    outer.style.top = "0px"
    outer.style.left = "0px"
    outer.style.visibility = "hidden"
    outer.style.width = "200px"
    outer.style.height = "150px"
    outer.style.overflow = "hidden"
    outer.appendChild inner
    document.body.appendChild outer
    w1 = inner.offsetWidth
    outer.style.overflow = "scroll"
    w2 = inner.offsetWidth
    w2 = outer.clientWidth  if w1 is w2
    document.body.removeChild outer
    scrollWidth = w1 - w2
    windowWidth = window.innerWidth - scrollWidth

    el.css 'width': windowWidth

    $(window).resize ->
      el.css 'width': windowWidth = window.innerWidth - scrollWidth
      return

    return

]



// WEBPACK FOOTER //
// ./src/app/common/directives/scroll-fix.directive.coffee